module.exports = __webpack_public_path__ + "img/IMeleeMonkey64_ua.f1acd890.webp";